import { useEffect } from "react";
import { useDashPermissionDispatch } from "../contexts/DashPermissionsContext";

export default function useGetDashPermissions() {
  const dashpermissionDispatch = useDashPermissionDispatch();

  useEffect(() => {
    dashpermissionDispatch({ type: "setIsLoadingDashPermissions", payload: true });

    let url = "/api/dashboards/permissions";
    fetch(url, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        dashpermissionDispatch({ type: "setDashPermissions", payload: data });
        dashpermissionDispatch({ type: "setIsLoadingDashPermissions", payload: false });
      });
  }, [dashpermissionDispatch]);
}
